const MAX_SIZE = 1280
const JPEG_QUALITY = 0.8

/**
 * Size that fits within MAX_SIZE on the longest side, keeping the aspect ratio. Never upscales.
 */
export function getScaledSize(width: number, height: number) {
    const scale = Math.min(1, MAX_SIZE / Math.max(width, height))

    return {width: Math.round(width * scale), height: Math.round(height * scale)}
}

/**
 * Draws an image or video frame on a canvas of at most MAX_SIZE px and returns it as JPEG data URL.
 */
export function toJpegDataUrl(source: HTMLImageElement | HTMLVideoElement, sourceWidth: number, sourceHeight: number) {
    const {width, height} = getScaledSize(sourceWidth, sourceHeight)

    const canvas = document.createElement('canvas')
    canvas.width = width
    canvas.height = height
    canvas.getContext('2d').drawImage(source, 0, 0, width, height)

    return canvas.toDataURL('image/jpeg', JPEG_QUALITY)
}

export function fileToJpegDataUrl(file: File) {
    return new Promise<string>((resolve, reject) => {
        const url = URL.createObjectURL(file)
        const img = document.createElement('img')

        img.onload = () => {
            try {
                resolve(toJpegDataUrl(img, img.naturalWidth, img.naturalHeight))
            } catch (err) {
                reject(err)
            } finally {
                URL.revokeObjectURL(url)
            }
        }

        img.onerror = () => {
            URL.revokeObjectURL(url)
            reject(new Error('Image could not be loaded'))
        }

        img.src = url
    })
}
